import useStores from 'shared/hooks/use-stores';

export default function useUser() {
  const { User } = useStores();

  return User;
}
